import React, { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CTable,
  CButton,
  CTableHead,
  CTableRow,
  CFormInput,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell, 
} from '@coreui/react';
import { fetchAuthSession  } from 'aws-amplify/auth';
import AWS from '../../aws-mock';

function Php() {

  const DYNAMODB_TABLE_NAME = 'codeflex';
  const REGION ='us-east-1';

  const dynamodb = new AWS.DynamoDB.DocumentClient({
    region: REGION,
    credentials: new AWS.Credentials({
      accessKeyId: process.env.REACT_APP_ACCESSKEYID,
      secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY
    }),
  });

  useEffect(() => {
    (async () => {
      try {
        await fetchAuthSession().then(data => 
        {
          leerptoyectos(data.tokens.accessToken.payload.username);
          setEmail(data.tokens.idToken.payload.email);
          setUser(data.tokens.accessToken.payload.sub);
        });

      } catch (err) {
        console.log(err);
      }

    })();	
	},[]);



  const [sub, setUser] = useState()
  const [base,SetDB] = useState();
  const [usuario,SetUsuario] = useState();
  const [email,setEmail] = useState();


  async function leerptoyectos(sub) {
    const params = {
      TableName: DYNAMODB_TABLE_NAME, 
      Key: {
        token: sub,
      },
    };
  
    try {
      const data = await dynamodb.get(params).promise();
      if (data.Item) {
        let validado = data.Item.premium;
        let Usuario = data.Item.MysqlUser;
        SetDB(validado);

        if (Usuario){
          SetUsuario(Usuario);
        }else{
          SetUsuario("Sin Cuenta en MySQL");
        }
        
      } else {
        console.log('Usuario no encontrado.');
      }
    } catch (err) {
      console.error('Error al buscar usuario:', err);
    }
  }
  const [searchInput, setSearchInput] = useState("");

  const actualizarPassword = () => {

    if (usuario == "Sin Cuenta en MySQL"){
      alert("¡No Dispones de una Cuenta en MySQL!")
    }else{
      if (searchInput) {
        let overlay = document.createElement('div');
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100%';
        overlay.style.height = '100%';
        overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
        overlay.style.display = 'flex';
        overlay.style.flexDirection = 'column';
        overlay.style.justifyContent = 'center';
        overlay.style.alignItems = 'center';
        overlay.style.zIndex = '9999';
        const spinner = document.createElement('div'); 
        spinner.className = 'spinner-border text-primary';
        spinner.setAttribute('role', 'status');
        const srOnly = document.createElement('span');
        srOnly.className = 'visually-hidden';
        srOnly.textContent = '';
        const downloadingText = document.createElement('p');
        downloadingText.textContent = 'Conectando....';
        downloadingText.style.marginTop = '10px';
        spinner.appendChild(srOnly);
        overlay.appendChild(spinner);
        overlay.appendChild(downloadingText);
        document.body.appendChild(overlay);

        const jsonData = {
          "action": "CAMBIARCONTRA",
          "username": usuario,
          "pass": searchInput
        };
    
        const options = {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(jsonData)
        };
    
        fetch("https://api.codeflex.com.co/mysql_connector", options)
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(data => {
            console.log(data.body)
            alert(data.body)
            document.body.removeChild(overlay);
            setSearchInput("")
          })
          .catch(error => {
            document.body.removeChild(overlay);
            alert("Error")
            window.location.reload();
            setSearchInput("")
            console.log(error)
          });
      } else {
        alert("Falta Contraseña")
      }
    }
  };
 
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={4}>

      {base ? 
          <CCol xs={12}>
          <CCard className="mb-4 ccard-custom-style">
          <CCardHeader>
            <strong className="text-primary">¡Bienvenidos a phpMyAdmin en CodeFlex! (Modo Premium)</strong>
          </CCardHeader>
          <CCardBody style={{ padding: 0, border: 'none' }}>
            <iframe 
              src="https://k.codeflex.com.co/Cloud/dashboard/" 
              style={{ border: 0, width: '100%', height: '100vh'}} 
              title="Dashboard" 
            />
          <CTable responsive bordered id="proyectos-table" small className="elegant-table">
             <CTableHead>
               <CTableRow>
                 <CTableHeaderCell scope="col">Usuario</CTableHeaderCell>
                 <CTableHeaderCell scope="col">Contraseña</CTableHeaderCell>
                 <CTableHeaderCell scope="col">Acción</CTableHeaderCell>
               </CTableRow>
             </CTableHead>
             <CTableBody>
                 <CTableRow className="row-hover">
                   <CTableDataCell className="td2"><center>{usuario}</center></CTableDataCell>
                   <CTableDataCell className="td2"><center>             
                   <CFormInput
                      type="text"
                      size="sm"
                      placeholder="Contraseña de MySQL"
                      aria-label="sm input example"
                      value={searchInput} 
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        // Verificar si hay espacios en la contraseña
                        if (!/\s/.test(inputValue)) {
                          setSearchInput(inputValue);
                        }
                      }}
                    />
                    </center></CTableDataCell>
                   <CTableDataCell className="td2"> 
                     <center>
                       <CButton component="a" color="success"  role="button" onClick={actualizarPassword}>
                         Activar
                       </CButton>
                     </center> 
                   </CTableDataCell>
                 </CTableRow>
             </CTableBody>
           </CTable>
           <p><strong><span style={{color:"tomato"}}>Nota:</span> Para crear el usuario y la contraseña, inicia sesión en Codeflex | MySQL. Este campo se utiliza para cambiar contraseña o activar la contraseña una vez finalizada la membresía. Es útil cuando el usuario renueva su membresía después de que haya vencido para activar nuevamente su MySQL.</strong></p>
           </CCardBody>
          </CCard>
         </CCol> 
          :
          <CCol xs={12}>
          <CCard className="mb-4 ccard-custom-style">
            <CCardHeader>
              <strong className="text-primary">
                Este servicio solamente se encuentra en modo premium
              </strong>
            </CCardHeader>
            <CCardBody>
              <p>
                El usuario {email} no se encuentra en dicho modo. Para acceder a este servicio, se recomienda activar su membresía.
              </p>
            </CCardBody>
          </CCard>
          </CCol>
          }<br/><br/><br/>
   
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Php;
